export default "__VITE_ASSET__C5RsC6eW__"